import React, { Component } from "react";
import PropTypes from "prop-types";
import CSSTransition from "react-transition-group/CSSTransition";
import styles from "./Fade.css";

class Fade extends Component {
  // HACK: iOS 10 and below do not like fixed with forms
  y = 0;

  handleEnter = () => {
    this.y = window.scrollY;
    window.scrollTo(0, 0);
    document.body.classList.add("chrome-bodylock");
  };

  handleExit = () => {
    const { onExit } = this.props;
    document.body.classList.remove("chrome-bodylock");
    window.scrollTo(0, this.y);
    onExit();
  };

  render() {
    const { isActive, children } = this.props;

    return (
      <CSSTransition
        in={isActive}
        mountOnEnter={true}
        unmountOnExit={true}
        timeout={500}
        onEnter={this.handleEnter}
        onExited={this.handleExit}
        classNames={{
          enter: styles.fade__entered,
          enterActive: styles.fade__entering,
          exit: styles.fade__exited,
          exitActive: styles.fade__exiting
        }}
      >
        <div className={styles.fade}>{children}</div>
      </CSSTransition>
    );
  }
}

Fade.defaultProps = {
  isActive: false,
  onExit: () => {}
};

Fade.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node,
  onExit: PropTypes.func
};

export default Fade;
